import { useNavigate, useParams } from "react-router-dom";
import DynamicFormPage from "../../components/DynamicFormPage";
import { getProductionStepDetails } from "../../helpers/http_production_steps_requests";
import { useQuery } from "@tanstack/react-query";

export default function ProductionStepDetails() {
    const navigate = useNavigate();
    const { id } = useParams();

    const { data, isFetching } = useQuery({
        queryKey: ["getProductionStepDetails", id],
        queryFn: () => getProductionStepDetails(id),
        staleTime: 1000 * 5,
    });

    const { data: stepData } = data?.data ?? {};

    const formFieldList = [
        {
            title: "Etapa - Detalhes",
            fields: [
                {
                    name: "name",
                    label: "Nome",
                    type: "text",
                },
                {
                    name: "slug",
                    label: "Slug",
                    type: "text",
                },
                {
                    name: "position",
                    label: "Ordem",
                    type: "number",
                },
                {
                    name: "is_active",
                    label: "Ativa",
                    type: "switch",
                },
            ],
        },
    ];

    return (
        <DynamicFormPage
            isLoading={isFetching}
            details
            initialData={stepData}
            title="Etapa - Detalhes"
            formFieldList={formFieldList}
            onCancel={() => navigate(-1)}
        />
    );
}
